import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

const requestTransferOrderRequest: RequestExample = {
    title: {
        verb: 'POST',
        endpointUrl: '/api/transfer-orders/:id/request',
    },
    curl:
        `curl --location \\
--request POST '<YOUR SERVER>/api/transfer-orders/<ID>/request' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const requestTransferOrderResponse: Json = {
    title: 'RESPONSE',
    json: {
        'id': 18,
        'number': 'TO-00018',
        'status': 'Request',
        'type': 'Ship',
        'fromLocationGroup': {
            'id': 1,
            'name': 'Main Warehouse'
        },
        'toLocationGroup': {
            'id': 2,
            'name': 'East Warehouse'
        },
        'carrier': {
            'id': 4,
            'name': 'Fedex',
            'service': {
                'id': 8,
                'name': 'Ground'
            }
        },
        'shipFromAddress': {
            'name': 'Main Warehouse',
            'street': '100 Main St',
            'city': 'Salt Lake City',
            'state': 'UT',
            'postalCode': '84101',
            'country': 'UNITED STATES'
        },
        'shipToAddress': {
            'name': 'East Warehouse',
            'street': '200 East Blvd',
            'city': 'Denver',
            'state': 'CO',
            'postalCode': '80201',
            'country': 'UNITED STATES'
        },
        'note': 'Restock request for east region',
        'ownerIsFrom': false,
        'revisionNumber': 1,
        'lastModified': {
            'username': 'admin',
            'dateLastModified': '2026-07-13T16:42:10.000+00:00'
        },
        'dateCreated': '2026-07-10T14:05:33.000+00:00',
        'dateScheduled': '2026-07-20T00:00:00.000+00:00',
        'dateConfirmed': '2026-07-12T00:00:00.000+00:00',
        'toItems': [
            {
                'id': 74,
                'part': {
                    'id': 28,
                    'name': 'B201',
                    'description': 'Premium Brake Cables'
                },
                'type': {
                    'id': 10,
                    'name': 'Send'
                },
                'status': 'Entered',
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'lineNumber': 1,
                'note': 'Needed before the weekend rush',
                'quantity': '25',
                'quantityFulfilled': '5',
                'quantityPicked': '5',
                'unitCost': '12.50',
                'dateScheduled': '2026-07-20T00:00:00.000+00:00'
            }
        ],
        'customFields': [
            {
                'id': 22,
                'name': 'Department',
                'value': 'Logistics',
                'type': 'Text'
            }
        ]
    },
};

const data: RequestDefinitionData = {
    id: 'request-transfer-order',
    title: 'Request a transfer order',
    description: 'Transitions a transfer order from Entered status to Request, signaling to the ' +
        'receiving party that the initiating party wants the transfer fulfilled. ' +
        'Requesting is only permitted for users with access to the owner location group but not both ' +
        'location groups — users with access to both should issue the transfer order directly. ' +
        'Returns 404 if the transfer order is not found.',
    endpoint: {
        verb: 'POST',
        path: '/transfer-orders/:id/request',
        tooltip: 'Request a transfer order',
    },
    attributes: [],
    requestObject: requestTransferOrderRequest,
    responseObject: requestTransferOrderResponse,
};

export default data;
